module.exports = __webpack_public_path__ + "img/minion_roll_thumb.28015d81.jpg";